import React, { useCallback, useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./sellerlanding.css";
import "animate.css";
import WOW from "wowjs";
import "wowjs/css/libs/animate.css";
import { Layout, Typography, Button, Row, Col, Card, Modal } from "antd";

import { ReactComponent as PartnerLogoIcon } from "../../../assets/seller/icons/mobPartnerlogo_black.svg";
import SKUAddIcon from "../../../assets/seller/icons/SKUAdd.webp";
import { ReactComponent as AssuredpaymentsIcon } from "../../../assets/seller/icons/Assuredpayments.svg";
import { ReactComponent as GreenTickIcon } from "../../../assets/seller/icons/greentick.svg";
import LoCIcon from "../../../assets/seller/icons/LoCCreation.webp";
import CashFlowIcon from "../../../assets/seller/icons/CashFlow.webp";
import MuthoothLogo from "../../../assets/seller/icons/muthooth.svg";
import MobCreditBlackIcon from "../../../assets/seller/icons/mobcredit-black.svg";
import RupifyLogo from "../../../assets/seller/icons/rupify_nobg.webp";
import MuthoothblackLogo from "../../../assets/seller/icons/muthooth_black.webp";
import liquiBlacklogo from "../../../assets/seller/icons/liqui_black.webp";
import { ReactComponent as CreditIcon } from "../../../assets/seller/icons/mobCreditAmount.svg";
import { ReactComponent as RepaymentIcon } from "../../../assets/seller/icons/repayment.svg";
import PartnerUserIcon from "../../../assets/seller/icons/partner-user.webp";
import PartnerUserNoBgIcon from "../../../assets/seller/icons/partner-user-nobg.webp";
import { ReactComponent as TickIcon } from "../../../assets/seller/icons/shieldtick.svg";
import { ReactComponent as CustomercreditIcon } from "../../../assets/seller/icons/customer_credit.svg";
import Mobcreditlogo from "../../../assets/seller/icons/Mobcreditlogo.svg";
import RupifyBlacklogo from "../../../assets/seller/icons/Rupify_black.webp";
import RazorPayIcon from "../../../assets/seller/icons/razorpay-black.webp";
import CreditActivelogo from "../../../assets/seller/icons/mobCredit_active.webp";
import CreditRejectlogo from "../../../assets/seller/icons/mobCredit_Reject.webp";
import CreditApplylogo from "../../../assets/seller/icons/mobCredit_Apply.webp";

import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FooterSection from "./components/FooterSection";

const { Header, Content } = Layout;
const Text = Typography;

const Seller = () => {
  useEffect(() => {
    document.title = "MOB | Seller Portal";
  }, []);

  const [modalVideoUrl, setModalVideoUrl] = useState("");
  const [activeKey, setActiveKey] = useState("1");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVideoTitle, setmodalVideoTitle] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const iframeRef = useRef(null);

  useEffect(() => {
    const wow = new WOW.WOW({ animateClass: "animated", offset: 100 });
    wow.init();
  }, []);

  const handleChange = useCallback((event) => {
    setSelectedValue(event.target.value);
  }, []);

  const handleModalOpen = useCallback((videoId, videoTitle) => {
    setModalVisible(true);
    setmodalVideoTitle(videoTitle);
    setModalVideoUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1`);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setModalVideoUrl("");
    setmodalVideoTitle("");
  }, []);

  const handlePhoneKeyDown = useCallback((e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }, []);

  return (
    <>
      <Layout className="web-layout">
        <Header className="header header-top-section fixed-top " style={{ backgroundColor: "white" }}>
          <div className="container">
            <div className="logo " style={{ float: "left" }}>
              <a href="/seller">
                <PartnerLogoIcon />
              </a>
            </div>
            <div style={{ float: "right" }}>
              <Button type="primary" onClick={() => window.open("/SellerLogin", "_blank")} className="register-style-btn">
                Login/ Register
              </Button>
            </div>
          </div>
        </Header>
        <Content>
          <HeroSection onPhoneKeyDown={handlePhoneKeyDown} />

          <section className="d-none d-md-none d-lg-block d-xl-block" style={{ backgroundColor: "white", padding: "40px 0" }}>
            <div className="container d-flex" style={{ margin: "0 auto", justifyContent: "space-between", gap: "40px", width: "100%", alignItems: "center", flexWrap: "wrap" }}>
              <span className="txt-enabling-partner"> Enabling partners</span>
              <img src={MuthoothblackLogo} className="partner-logo" alt="Partner logo 1" />
              <img src={liquiBlacklogo} className="partner-logo" alt="Partner logo 2" />
              <img src={MobCreditBlackIcon} className="partner-logo" alt="Partner logo 3" />
              <img src={RupifyBlacklogo} className="partner-logo" alt="Partner logo 4" />
              <img src={RazorPayIcon} className="partner-logo" alt="Partner logo 5" />
            </div>
          </section>

          <section className="d-block d-sm-block d-lg-none d-xl-none" style={{ backgroundColor: "white", padding: "40px 0" }}>
            <Row className="container d-flex">
              <Col className="text-center" span={24}>
                <Text className="txt-enabling-partner text-center"> Enabling partners</Text>
              </Col>
              <Col className="text-center" span={24}>
                <img src={MuthoothblackLogo} className="partner-logo" alt="Partner logo 1" />
                <img src={liquiBlacklogo} className="partner-logo" alt="Partner logo 2" />
                <img src={MobCreditBlackIcon} className="partner-logo" alt="Partner logo 3" />
                <img src={RupifyBlacklogo} className="partner-logo" alt="Partner logo 4" />
                <img src={RazorPayIcon} className="partner-logo" alt="Partner logo 5" />
              </Col>
            </Row>
          </section>

          <section className="wow fadeInUp d-none d-md-none d-lg-block d-xl-block">
            <div className="container" style={{ margin: "0 auto" }}>
              <Card className="card-light-green-section p-0" style={{ margin: "0 auto" }}>
                <Row gutter={[16, 16]} className="p-0" justify="space-between" style={{ alignItems: "center" }}>
                  <Col className="card-padding-custom" md={10}>
                    <p className="txt-mobPartnet-heading">mobPARTNER is for</p>
                    <p className="text-font-list"><GreenTickIcon /> Construction material suppliers</p>
                    <p className="text-font-list"><GreenTickIcon /> Interior material suppliers</p>
                    <p className="text-font-list"><GreenTickIcon /> Manufacturers & D2C brands</p>
                  </Col>
                  <Col md={8} className="partner-user-img text-right">
                    <img src={PartnerUserIcon} alt="" width={"80%"} />
                  </Col>
                </Row>
              </Card>
            </div>
          </section>

          <section className="wow fadeInUp d-block d-sm-block d-lg-none d-xl-none">
            <div className="container">
              <Card className=" card-light-green-section p-0" style={{ margin: "0 auto" }}>
                <Row gutter={[16, 16]} className="p-0" justify="space-between" style={{ alignItems: "center" }}>
                  <Col className="card-padding-custom" md={10}>
                    <h2 className="txt-mobPartnet-heading">mobPARTNER is for</h2>
                    <p className="text-font-list"><GreenTickIcon /> Construction material suppliers</p>
                    <p className="text-font-list"><GreenTickIcon /> Interior material suppliers</p>
                    <p className="text-font-list"><GreenTickIcon /> Manufacturers & D2C brands</p>
                  </Col>
                  <Col md={8} className="partner-user-img text-center width-100">
                    <img src={PartnerUserNoBgIcon} alt="" width={"50%"} />
                  </Col>
                </Row>
              </Card>
            </div>
          </section>

          <section className="wow fadeInUp main-common-padding" style={{ backgroundColor: "white" }}>
            <div className="container" style={{ margin: "0 auto" }}>
              <h2 className="credit-heading-black text-center"><span className="credit-heading-bg"> Line of credit issues?</span> We have you covered</h2>
              <Row className="mt-4"><Col span={24} className="card-risk-section d-flex"><TickIcon /><span className="text-heading-sm ml-16px">You carry zero risk on client’s default</span></Col></Row>
              <Row gutter={[24, 24]} justify="center" style={{ marginTop: "24px", flexWrap: "flex" }}>
                <Col md={8}>
                  <Card className="card-light-section-common height-100">
                    <CustomercreditIcon className="credt-icon-top" />
                    <h3 className="txt-credit-section-heading">Give <span className="text-common-green"> line of credit</span> to your customers</h3>
                    <p style={{ marginTop: "16px" }}>Sell instantly to clients already on line of credit or add your client to onboard them to line of credit.</p>
                    <img src={Mobcreditlogo} className="mobile-logo-size" alt="" />
                  </Card>
                </Col>
                <Col md={8} style={{ flex: "1" }}>
                  <Card className="card-light-section-common height-100">
                    <CreditIcon className="credt-icon-top" />
                    <h3 className="txt-credit-section-heading">Up to <span className="text-common-green">50 Lakhs</span> per client (90 days)</h3>
                    <p style={{ marginTop: "16px" }}>90 days line of credit for your client (21 days is interest free for your client)</p>
                    <p>Backed by</p>
                    <Col className="d-flex" style={{ gap: "10px" }}>
                      <img src={MuthoothLogo} className="" alt="Partner logo 1" />
                      <img src={RupifyLogo} className="" alt="Partner logo 4" />
                    </Col>
                  </Card>
                </Col>
                <Col md={8} style={{ flex: "1" }}>
                  <Card className="card-light-section-common height-100">
                    <RepaymentIcon className="credt-icon-top" />
                    <h3 className="txt-credit-section-heading"><span className="text-common-green"> Assured payment </span> in T+2 days</h3>
                    <p style={{ marginTop: "16px", marginBottom: "24px" }}>Assured payment on full delivery of your sales transactions. Order amount is credited via OTP by client.</p>
                    <AssuredpaymentsIcon />
                  </Card>
                </Col>
              </Row>
            </div>
          </section>

          <section className="container ">
            <div className=" card-light-section-common" style={{ margin: "0 auto", padding: "24px" }}>
              <h2 className="txt-dark-bold">Use existing mobCREDIT clients <br /><span className="txt-green-dark"> or add your clients</span></h2>
              <Row gutter={[24, 24]} justify="center" style={{ marginTop: "40px" }}>
                <Col md={8}><img src={CreditActivelogo} width={"100%"} alt="mobCredit"></img></Col>
                <Col md={8}><img src={CreditRejectlogo} width={"100%"} alt="mobCredit"></img></Col>
                <Col md={8}><img src={CreditApplylogo} width={"100%"} alt="mobCredit"></img></Col>
              </Row>
            </div>
          </section>

          <section className="wow fadeInUp main-common-padding" style={{ backgroundColor: "white" }}>
            <div className="container" style={{ margin: "0 auto" }}>
              <h2 className="txt-font-bigger">Grow your construction & interior material <br /> business with mobCREDIT</h2>
              <Row gutter={[24, 24]} className="mt-4">
                <Col xs={24} md={12}>
                  <Card className="mb-2 card-easyline lineofcredit-bg-img">
                    <Text className="font-large-text">Easy line of credit sales creation</Text>
                    <Text className="font-medium-text">mobCREDIT based sales can be created instantly for approved clients with their OTP confirmation</Text>
                    <Col className="text-center mt-4"><img src={LoCIcon} className="img-lineofcredit" alt=""></img></Col>
                  </Card>
                  <Card className="mt-4 card-onboarding">
                    <Text className="font-large-text">Activate mobCREDIT now!</Text>
                    <Text className="font-medium-text">Activate mobCREDIT immediately upon login (add your business and personal GSTIN, Aadhar and PAN)</Text>
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card className="mb-2 card-guarenteed">
                    <Text className="font-large-text">Guaranteed payment <TickIcon /> </Text>
                    <Text className="font-medium-text">Guaranteed payment upon delivery confirmation and your invoice in 2 working days</Text>
                  </Card>
                  <Card className="mt-4 card-optimise">
                    <Text className="font-large-text">Optimise your cash flow</Text>
                    <Text className="font-medium-text">You get paid in t+2 working days and your buyers (Architects & contractors) can pay pack within 90 days.</Text>
                    <Col className="text-center mt-4"><img src={CashFlowIcon} className="img-lineofcredit1" alt=""></img></Col>
                  </Card>
                </Col>
              </Row>
            </div>
          </section>

          <HowItWorksSection activeKey={activeKey} setActiveKey={setActiveKey} handleModalOpen={handleModalOpen} />

          <section className="wow fadeInUp d-none d-md-none d-lg-block d-xl-block main-common-padding" style={{ backgroundColor: "#e6f7ff" }}>
            <div className="container" style={{ margin: "0 auto" }}>
              <Row gutter={[16, 16]} justify="space-between">
                <Col className="catalogue-bg-img" md={24}>
                  <h2 className="txt-font-bigger text-left">2.5 lakhs SKU's prebuilt to <br /> make your custom catalogue <br /> in minutes⚡️</h2>
                  <p className="txt-font-medium" style={{ marginTop: "16px" }}>You can also add items manually</p>
                  <Button type="primary" onClick={() => window.open("/SellerLogin", "_blank")} className="register-style-btn">Register now</Button>
                  <p className="txt-font-sm" style={{ marginTop: "16px" }}>It takes less than 1 minute to register</p>
                </Col>
              </Row>
            </div>
          </section>

          <section className="wow fadeInUp d-block d-sm-block d-lg-none d-xl-none" style={{ backgroundColor: "#e6f7ff", padding: "12px 12px 0px 12px" }}>
            <div className="container" style={{ margin: "0 auto" }}>
              <Row gutter={[16, 16]} justify="space-between">
                <Col className="" span={24}>
                  <h2 style={{ fontSize: "28px", fontWeight: "bold", textAlign: "left" }}>2.5 lakhs SKU's prebuilt to <br /> make your custom catalogue <br /> in minutes⚡️</h2>
                  <p style={{ marginTop: "16px" }}>You can also add items manually</p>
                  <Button type="primary" onClick={() => window.open("/SellerLogin", "_blank")} className="register-style-btn">Register now</Button>
                  <p style={{ marginTop: "16px" }}>It takes less than 1 minute to register</p>
                </Col>
                <Col span={24}><img src={SKUAddIcon} alt="Catalogue" style={{ marginTop: "16px", width: "100%" }} /></Col>
              </Row>
            </div>
          </section>

          <TestimonialsSection />
        </Content>

        <FooterSection selectedValue={selectedValue} handleChange={handleChange} />
      </Layout>

      <Modal className="youtube-modal" width={"75%"} height={"75%"} wrapClassName="modal-center" title={modalVideoTitle} visible={modalVisible} destroyOnClose onCancel={handleModalClose} footer={null}>
        {modalVisible && (
          <iframe
            id="youtube-iframe"
            ref={iframeRef}
            width="100%"
            height="100%"
            src={modalVideoUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            onClick={() => {
              if (iframeRef.current?.requestFullscreen) {
                iframeRef.current.requestFullscreen();
              }
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default Seller;
